module.exports = __webpack_public_path__ + "img/totalmeetings500.1ad5e0c3.png";